import React from 'react';
import EventForm from './EventForm';

class NewEventPage extends React.Component {
  render() {
    return (
      <div>
        <EventForm />
      </div>
    );
  }
}

export default NewEventPage;



// WEBPACK FOOTER //
// ./client/components/events/NewEventPage.js